import { Component, Input, OnInit, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { GenericValue } from 'hisng';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';
import { ResearchInfrastructureEmployment } from '../../model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-usage-tab',
    templateUrl: './research-infrastructure-usage-tab.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureUsageTabComponent)],
} )
export class ResearchInfrastructureUsageTabComponent implements OnInit {
    @Input() researchInfrastructure: ResearchInfrastructure;
    @Input() usageTypes: GenericValue[];
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    public i18nKeyParameter: { [key: number]: string };

    ngOnInit() {
        this.setI18nKeyParameters();
    }

    private setI18nKeyParameters() {
        this.i18nKeyParameter = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            10: 'internalUser',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            11: 'externalUser',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            12: 'hours',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            13: 'usageAccesses'
        };
    }

}
